document.addEventListener("click", function (event) {
    const cardElement = event.target.closest(".recently-viewed-products__product");
    if (!cardElement) return;

    if (event.target.classList.contains("product-card__size-btn")) {
        event.preventDefault();
        const selectedVariantLi = event.target;
        const variantId = selectedVariantLi.dataset.variant;
        const allVariants = cardElement.querySelectorAll(".product--card-variant_swatch");

        allVariants.forEach(li => li.classList.remove("js-selected-variant"));
        selectedVariantLi.classList.add("js-selected-variant");

        cardElement.querySelector('[name="id"]').value = variantId;
        const atcBtn = cardElement.querySelector(".productCard--atc");
        atcBtn.setAttribute("value", "Add to Cart");
        atcBtn.classList.remove("atc-soldOut");
        atcBtn.removeAttribute("disabled");
    }

    if (event.target.classList.contains("product-card__size-btn-nostock")) {
        event.preventDefault();
        const selectedVariantLi = event.target;
        const allVariants = cardElement.querySelectorAll(".product--card-variant_swatch");

        allVariants.forEach(li => li.classList.remove("js-selected-variant"));
        selectedVariantLi.classList.add("js-selected-variant");

        const atcBtn = cardElement.querySelector(".productCard--atc");
        atcBtn.setAttribute("value", "Sold Out");
        atcBtn.classList.add("atc-soldOut");
        atcBtn.setAttribute("disabled", true);
    }

    if (event.target.classList.contains("productCard--atc")) {
        event.preventDefault();
        const atcBtn = cardElement.querySelector(".productCard--atc");
        atcBtn.setAttribute("value", "Adding...");

        setTimeout(() => {
            const addToCartForm = cardElement.querySelector("form");
            let cartConfig = document.getElementById("cart-config");
            if (!cartConfig) return;
            cartConfig = JSON.parse(cartConfig.innerHTML || "{}");

            atcBtn.setAttribute("value", "Added to cart");
            Shopify.theme.ajaxCart.addToCart(addToCartForm, cardElement, cartConfig, false);

            setTimeout(() => {
                atcBtn.setAttribute("value", "Add to cart");
            }, 1000);
        }, 500);
    }

    if (event.target.classList.contains("swatch-radio")) {
        event.preventDefault();
        const variant = event.target.dataset.variant;
        const handle = cardElement.dataset.handle;
        const variantUrl = `/products/${handle}?view=card&variant=${variant}`;

        fetch(variantUrl)
            .then(res => res.text())
            .then(htmlString => {
                const html = new DOMParser().parseFromString(htmlString, "text/html");
                const newCard = html.querySelector(".recently-viewed-products__product");
                cardElement.innerHTML = newCard.innerHTML;

                const swatch = cardElement.querySelector(`.swatch-radio[data-variant="${variant}"]`);
                if (swatch) swatch.style.border = "1px solid #13294b";
            });
    }

    if (event.target.classList.contains("color-swatch-radio")) {
        event.preventDefault();
        const variant = event.target.dataset.variant;
        const handle = event.target.dataset.handle;
        const variantUrl = `/products/${handle}?view=card&variant=${variant}`;

        fetch(variantUrl)
            .then(res => res.text())
            .then(htmlString => {
                const html = new DOMParser().parseFromString(htmlString, "text/html");
                const newCard = html.querySelector(".recently-viewed-products__product");
                cardElement.innerHTML = newCard.innerHTML;

                const swatch = cardElement.querySelector(`.color-swatch-radio[data-variant="${variant}"]`);
                if (swatch) swatch.style.border = "1px solid #13294b";
            });
    }

    if (event.target.closest(".share_button") && window.innerWidth < 769) {
        event.preventDefault();
        cardElement.classList.toggle("share-open");
    }
});

document.addEventListener("mouseover", function (event) {
    if (window.innerWidth >= 769 && event.target.closest(".social_media_container")) {
        const cardElement = event.target.closest(".recently-viewed-products__product");
        if (cardElement) {
            cardElement.classList.add("share-open");
        }
    }
});

document.addEventListener("mouseout", function (event) {
    if (window.innerWidth >= 769 && event.target.closest(".social_media_container")) {
        const cardElement = event.target.closest(".recently-viewed-products__product");
        if (cardElement) {
            cardElement.classList.remove("share-open");
        }
    }
});
